module.exports = __webpack_public_path__ + "img/problem-top-mobile.c5439c98.png";